import {
  SET_PURCHASE_PLACES,
  SET_PURCHASE_PLACES_LOADING,
  UNSET_PURCHASE_PLACES_LOADING,
  SET_SERIAL_NUMBER_MANDATORY,
} from '@/context/purchasePlaces/types';

export default (state, action) => {
  switch (action.type) {
    case SET_PURCHASE_PLACES_LOADING:
      return { ...state, purchasePlacesLoading: true };
    case UNSET_PURCHASE_PLACES_LOADING:
      return { ...state, purchasePlacesLoading: false };
    case SET_PURCHASE_PLACES:
      return { ...state, purchasePlaces: action.payload };
    case SET_SERIAL_NUMBER_MANDATORY:
      return { ...state, serialNumberMandatory: action.payload };
    default:
      return { ...state };
  }
};
